import React from "react";
import { Button, Col, Row, Select } from "antd";
import { ClearOutlined, FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import ConfigurableRangePicker from "../../compoinents/ConfigurableRangePicker";
import DebounceSelect from "../../compoinents/DebouncedSelect";

const DashboardMasthead = ({
  isMobile,
  loading,
  showFilters,
  onToggleFilters,
  loadWithFilter,
  filterDateLabel,
  lastUpdated,
  onRefresh,
  onClearFilters,
  filter,
  setFilter,
  packages,
  states,
  loadOrgs,
  pickerRef,
  onDateChange,
  onApplyFilters,
}) => (
  <>
    <header className="dash-masthead">
      <div className="dash-masthead__lead">
        <h1 className="dash-masthead__title">Dashboard</h1>
        <p className="dash-masthead__meta">
          {filterDateLabel ? <span>{filterDateLabel}</span> : null}
          {filterDateLabel && lastUpdated ? <span className="dash-masthead__sep">·</span> : null}
          {lastUpdated ? <span>Updated {lastUpdated}</span> : null}
        </p>
      </div>
      <div className="dash-masthead__actions">
        <button
          type="button"
          className={`dash-icon-btn ${showFilters ? "is-active" : ""}`}
          onClick={onToggleFilters}
          aria-label="Toggle filters"
          aria-expanded={showFilters}
        >
          <FilterOutlined />
          {loadWithFilter ? <span className="dash-icon-btn__dot" /> : null}
        </button>
        {loadWithFilter ? (
          <button type="button" className="dash-icon-btn" onClick={onClearFilters} aria-label="Clear filters">
            <ClearOutlined />
          </button>
        ) : null}
        <Button
          type="primary"
          size="small"
          icon={<ReloadOutlined spin={loading} />}
          onClick={onRefresh}
          disabled={loading}
          className="dash-masthead__refresh"
        >
          {isMobile ? null : "Refresh"}
        </Button>
      </div>
    </header>

    {showFilters ? (
      <div className="dash-filters">
        <Row gutter={[10, 10]} align="middle">
          <Col xs={24} sm={12} md={6} lg={5}>
            <ConfigurableRangePicker
              ref={pickerRef}
              onChange={onDateChange}
              pickerType="day"
              className="filter-date-picker"
              placeholder={["Start", "End"]}
            />
          </Col>
          <Col xs={24} sm={12} md={5} lg={4}>
            <Select
              placeholder="State"
              options={states}
              className="filter-select"
              value={filter?.state}
              onChange={(value) => setFilter((d) => ({ ...d, state: value }))}
              allowClear
              showSearch
            />
          </Col>
          <Col xs={24} sm={12} md={5} lg={4}>
            <Select
              placeholder="Package"
              options={packages}
              className="filter-select"
              value={filter?.package}
              onChange={(value) => setFilter((d) => ({ ...d, package: value }))}
              allowClear
              showSearch
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={7}>
            <DebounceSelect
              value={filter?.social}
              fetchOptions={loadOrgs}
              onChange={(value) => setFilter((d) => ({ ...d, social: value }))}
              placeholder="Organization"
              className="filter-select"
              allowClear
              showSearch
            />
          </Col>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Button
              type="primary"
              icon={<FilterOutlined />}
              onClick={onApplyFilters}
              disabled={loadWithFilter}
              className="dash-filters__apply"
              block
            >
              Apply
            </Button>
          </Col>
        </Row>
      </div>
    ) : null}
  </>
);

export default DashboardMasthead;
